var map = {
	"./bicep.svg": "f0a0",
	"./bus.svg": "6278",
	"./cinema.svg": "ac7e",
	"./meal.svg": "b2e1",
	"./question-mark.svg": "6195",
	"./ship.svg": "c899",
	"./theater.svg": "0777",
	"./tour.svg": "54e5",
	"./volleyball.svg": "e3bf",
	"./yoga.svg": "094f"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8291";